.gz{z-index:2;}